<div class="chat-container" fxLayout="column">
  <div
    class="header"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    fxFlex="10"
  >
    <button
      mat-icon-button
      *ngIf="memberSelected"
      (click)="memberSelected = null; conversationSelected = null"
    >
      <mat-icon class="close-icon">arrow_back</mat-icon>
    </button>

    <span *ngIf="!memberSelected" class="ml-3 title-chat">Messages</span>

    <div *ngIf="memberSelected" class="memeber" fxLayout="row">
      <mat-icon
        [ngClass]="{
          'active-memeber': memberSelected.on_line === true,
          'inactive-memeber': memberSelected.on_line === false
        }"
        >fiber_manual_record</mat-icon
      >
      <span class="ml-2 title-chat">
        {{
          memberSelected.name + ' ' + memberSelected.last_name | titlecase
        }}</span
      >
    </div>
    <button mat-icon-button (click)="emitClose.emit(true)">
      <mat-icon class="close-icon">close</mat-icon>
    </button>
  </div>
  <div class="content" fxFlex="90">
    <app-messages-handler
      *ngIf="!memberSelected"
      [members]="members"
      [recentContacts]="previousConversations"
      [conversations]="conversations"
      (selectMember)="talkTo($event)"
      (selectPreviosContact)="talkToPreviousContact($event)"
      (selectConversation)="selectConversation($event)"
    ></app-messages-handler>
    <app-conversation
      *ngIf="memberSelected"
      [conversation]="conversationSelected"
      [memberSelected]="memberSelected"
      (emitMessage)="emitMessage($event)"
    ></app-conversation>
  </div>
</div>
